// Website blog index and post (the Blog design export). Spread into en.ts / bn.ts.
// Tenant-blind (INF-1): {brand} / {region} placeholders.
export const blogPageEn = {
  'blog.cat.all': 'All',
  'blog.cat.reviews': 'Reviews',
  'blog.cat.offers': 'Offers',
  'blog.cat.pricing': 'Pricing',
  'blog.cat.verification': 'Verification',
  'blog.cat.operations': 'Operations',
  'blog.cat.travel': 'Travel',
  'blog.categories': 'Categories',
  'blog.search': 'Search articles',
  'blog.latest': 'Latest articles',
  'blog.results': 'Search results',
  'blog.count_one': '1 article',
  'blog.count': '{n} articles',
  'blog.nothing': 'Nothing found. Try another word.',
  'blog.load_more': 'Load more articles',
  'blog.home': 'Home',
  'blog.blog': 'Blog',
  'blog.breadcrumb': 'Breadcrumb',
  'blog.published': 'Published',
  'blog.updated': 'Updated',
  'blog.in_article': 'In this article',
  'blog.faq_short': 'FAQ',
  'blog.share': 'Share',
  'blog.copy_link': 'Copy link',
  'blog.link_copied': 'Link copied',
  'blog.prev': 'Previous',
  'blog.next': 'Next',
  'blog.prev_next': 'Previous and next',
  'blog.cta_title': 'List your business on {brand}, free',
  'blog.cta_body': 'Hotels, turfs, restaurants: post offers, collect reviews, get verified.',
  'blog.cta_btn': 'Add your business',
} as const satisfies Record<string, string>;

export const blogPageBn = {
  'blog.cat.all': 'সব',
  'blog.cat.reviews': 'রিভিউ',
  'blog.cat.offers': 'অফার',
  'blog.cat.pricing': 'প্রাইসিং',
  'blog.cat.verification': 'ভেরিফিকেশন',
  'blog.cat.operations': 'অপারেশনস',
  'blog.cat.travel': 'ভ্রমণ',
  'blog.categories': 'ক্যাটাগরি',
  'blog.search': 'আর্টিকেল খুঁজুন',
  'blog.latest': 'সর্বশেষ আর্টিকেল',
  'blog.results': 'সার্চ ফলাফল',
  'blog.count_one': '১টি আর্টিকেল',
  'blog.count': '{n}টি আর্টিকেল',
  'blog.nothing': 'কিছু পাওয়া যায়নি। অন্য শব্দে খুঁজুন।',
  'blog.load_more': 'আরও আর্টিকেল',
  'blog.home': 'হোম',
  'blog.blog': 'ব্লগ',
  'blog.breadcrumb': 'ব্রেডক্রাম্ব',
  'blog.published': 'প্রকাশ',
  'blog.updated': 'আপডেট',
  'blog.in_article': 'এই আর্টিকেলে',
  'blog.faq_short': 'প্রশ্নোত্তর',
  'blog.share': 'শেয়ার',
  'blog.copy_link': 'লিংক কপি',
  'blog.link_copied': 'লিংক কপি হয়েছে',
  'blog.prev': 'আগের',
  'blog.next': 'পরের',
  'blog.prev_next': 'আগের ও পরের',
  'blog.cta_title': 'আপনার ব্যবসা {brand}-তে বিনামূল্যে লিস্ট করুন',
  'blog.cta_body': 'হোটেল, টার্ফ, রেস্টুরেন্ট: অফার পোস্ট করুন, রিভিউ পান, ভেরিফায়েড হোন।',
  'blog.cta_btn': 'ব্যবসা যুক্ত করুন',
} as const satisfies Record<keyof typeof blogPageEn, string>;
